import { render, staticRenderFns } from "./TreeBranchWrapper.vue?vue&type=template&id=0dcc7b20&"
import script from "./TreeBranchWrapper.vue?vue&type=script&lang=ts&"
export * from "./TreeBranchWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports